import type { QueryClient } from '@tanstack/react-query';

import type { Deal } from '../types';

export const dealDetailQueryKey = (id: string) => ['deals', 'detail', id] as const;

export function cacheDealDetail(queryClient: QueryClient, id: string, deal: Deal) {
  queryClient.setQueryData(dealDetailQueryKey(id), deal);
}
